import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
    assignModelOptions,
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigService,
    ConfirmationExpensesModel,
    EventService,
    TextModel,
} from '@evorait/pace-core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pace-confirmation-expenses',
    templateUrl: './confirmation-expenses.component.html',
    styleUrls: ['./confirmation-expenses.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationExpensesComponent implements OnInit, OnDestroy {
    @Input()
    public model: ConfirmationExpensesModel;

    @Input()
    public parentForm: FormArray;

    public phoneFixChangedSubscription: Subscription;
    public constructor(
        public readonly eventService: EventService,
        public readonly changeDetector: ChangeDetectorRef,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        public readonly configService: ConfigService,
    ) {}

    public ngOnInit(): void {
        if (this.clientManager.isNgmP58OrSA() && this.model.displayDistance) {
            this.phoneFixChangedSubscription = this.eventService.phoneFixSelected$.subscribe((isPhoneFixSelected) => {
                // if phonefix is selected then adding a distance value is not allowed
                if (this.model.distance && isPhoneFixSelected) {
                    const distance = assignModelOptions(
                        this.model.distance,
                        {
                            ...this.model.distance.options,
                            readonly: isPhoneFixSelected,
                        },
                        this.model,
                    );
                    distance.value = '';
                    this.model.distance = <TextModel>this.model.set(distance);
                    // If distance field is not editable, then hide the Mileage Travel section
                    this.model.displayMileageTravel =
                        this.configService.getUseMileageHistory() && !distance.options.readonly;
                }
                this.changeDetector.detectChanges();
                this.parentForm.controls.forEach((control) => control.updateValueAndValidity());
            });
        }
    }

    public ngOnDestroy(): void {
        if (typeof this.phoneFixChangedSubscription !== 'undefined') {
            this.phoneFixChangedSubscription.unsubscribe();
        }
    }
}
